import styled, { css } from 'styled-components'
import {
	textModels,
	themeObject,
	media,
	Breakpoints,
} from 'Pages/landings/newLandings/common/style'
import { ColorNames } from 'Pages/landings/newLandings/common/constants'

export const Button = styled.button<{ measure: string; buttonType: string; isLoading: boolean }>`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	border-radius: 8px;
	flex-shrink: 0;
	width: 100%;
	${media('width: auto;', Breakpoints.ms)}
	${({ measure, isLoading }) => {
		const paddingWithLoading = isLoading ? '12px 16px' : '12px 20px'
		switch (measure) {
			case 'l':
				return css`
					height: 48px;
					${textModels('notAdaptive', 'm', '400')}
					padding: ${paddingWithLoading};
				`
			case 'm':
				return css`
					height: 40px;
					${textModels('notAdaptive', 's', '400')} padding: 10px 16px;
				`
			case 's':
				return css`
					height: 32px;
					${textModels('notAdaptive', 'xs')} padding: 8px 12px;
				`
			default:
				return ''
		}
	}}
	${({ buttonType, isLoading }) => {
		switch (buttonType) {
			case ColorNames.PRIMARY:
				return css`
					color: ${themeObject.colors.base.white};
					background: ${isLoading
						? `${themeObject.colors.brand[400]}`
						: `${themeObject.colors.brand[500]}`};
					cursor: ${isLoading ? 'not-allowed' : 'pointer'};
					&:disabled {
						color: ${isLoading
							? `${themeObject.colors.base.white}`
							: `${themeObject.colors.grey[300]}`};
						background: ${isLoading
							? `${themeObject.colors.brand[400]}`
							: `${themeObject.colors.grey[100]}`};
					}
					&:hover {
						background: ${isLoading
							? `${themeObject.colors.brand[400]}`
							: `${themeObject.colors.brand[600]}`};
					}
					&:active {
						background: ${themeObject.colors.brand[700]};
					}
					&:focus {
						background: ${isLoading
							? `${themeObject.colors.brand[400]}`
							: `${themeObject.colors.brand[500]}`};
						box-shadow: ${isLoading ? 'none' : `0 0 0 4px ${themeObject.colors.brand[200]}`};
					}
				`
			case ColorNames.SECONDARY:
				return css`
					color: ${themeObject.colors.brand[500]};
					box-shadow: 0 0 0 1px ${themeObject.colors.brand[500]};
					background: ${themeObject.colors.base.white};
					&:hover {
						background: ${themeObject.colors.brand[50]};
					}
					&:focus {
						color: ${themeObject.colors.brand[500]};
						box-shadow: 0 0 0 1px ${themeObject.colors.brand[500]},
							0 0 0 4px ${themeObject.colors.brand[200]};
						background: ${themeObject.colors.grey[100]};
					}
					&:active {
						color: ${themeObject.colors.brand[600]};
						box-shadow: 0 0 0 1px ${themeObject.colors.brand[600]};
						background: ${themeObject.colors.brand[50]};
					}
					&:disabled {
						color: ${themeObject.colors.grey[300]};
						box-shadow: 0 0 0 1px ${themeObject.colors.grey[200]};
						background: ${themeObject.colors.grey[200]};
					}
				`
			case ColorNames.TERTIARY:
				return css`
					color: ${themeObject.colors.grey[700]};
					box-shadow: 0 0 0 1px ${themeObject.colors.grey[200]};
					background: ${themeObject.colors.base.white};
					&:hover {
						background: ${themeObject.colors.grey[50]};
					}
					&:focus {
						box-shadow: 0 0 0 4px ${themeObject.colors.grey[100]};
					}
					&:active {
						box-shadow: 0 0 0 1px ${themeObject.colors.brand[600]};
						background: ${themeObject.colors.brand[50]};
					}
					&:disabled {
						color: ${themeObject.colors.grey[300]};
						box-shadow: 0 0 0 1px ${themeObject.colors.grey[200]};
					}
				`
			case ColorNames.GHOST:
				return css`
					color: ${themeObject.colors.grey[800]};
					background: ${themeObject.colors.base.white};
					&:hover {
						background: ${themeObject.colors.grey[200]};
					}
					&:focus {
						box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.2);
					}
					&:active {
						background: ${themeObject.colors.brand[300]};
					}
					&:disabled {
						color: ${themeObject.colors.grey[300]};
						background: ${themeObject.colors.grey[50]};
					}
				`
			case ColorNames.MALACHITE:
				return css`
					color: ${themeObject.colors.base.white};
					background: ${themeObject.colors.malachite[500]};
					&:hover {
						background: ${themeObject.colors.malachite[400]};
					}
					&:focus {
						box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.2);
					}
					&:active {
						background: ${themeObject.colors.malachite[300]};
					}
					&:disabled {
						color: ${themeObject.colors.grey[300]};
						background: ${themeObject.colors.malachite[50]};
					}
				`
			default:
				return ''
		}
	}}
`

export const SpinnerWrapper = styled.div`
	margin-left: 8px;
`
